<template>
<div>
     <navbar-tournoi
            :club="club"
            :tournoi="tournoi"
            
            :role="role"
            display="resultat"
           
            @back="$emit('back')"
        />
     
    <div style="padding-top: 100px;width:100%">
        <div style="float:left;padding-left: 20px">
          
            <s-button icon="check" 
                        label="Clôturer le tournoi"
                        theme="is-success is-small" @onclick="modalCloturer=true" 
                        v-show="tournoi.state!='FINISH'"
                        :role="role"
            />
        </div>
        <div style="float:right;padding-right: 20px">
            <s-button icon="play" label="Reprendre" theme="is-success is-small" @onclick="$emit('viewGame')" />
        </div>
    </div>
    <div style="padding-top: 50px;padding-left: 20px;text-align:center">
    <s-confirm
            title="Clôturer le tournoi"
            @yes="cloturer"
            @no="modalCloturer=false"
            :open="modalCloturer">
           
            <div class="notification is-light">
                <s-l id="resultat_explain">Une fois le tournoi clouré, il sera considéré comme "Archivés" <br/>
                Vous pouvez le retrouver dans la liste des tournois de votre club pour visualiser les résultats en cliquant sur "Archivés"<br/>
                </s-l>
            </div>
            <div class="notification is-danger">
                Il sera archivé pendant une période de 
                <span v-show="tournoi.options.mode == 'FREE'">
                    24 heures
                </span>
                <span v-show="tournoi.options.mode != 'FREE'">
                    2 ans
                </span>
                <br/>
                Au delà il sera définitivement supprimé...
            </div><hr/>
            <span class="title is-3"> <s-l id="resultat_confirm">Souhaitez vous clore ce tournoi ?</s-l></span>
    </s-confirm>
    
    <div class="tabs">
        <ul>
            <li :class="tab=='poules' ? 'is-active' : ''" >
                <a v-on:click="tab='poules'">Poules</a></li>
            <li :class="tab=='eliminatoire'  ? 'is-active' : ''">
                <a  v-on:click="tab='eliminatoire'">Eliminatoires</a></li>
        </ul>
    </div>
        <div class="pools" v-show="tab=='poules'" >
            <div v-for="(pool, indexPool) in poolsResultats" class="pool">
            <table border="1" style="width:100%">
                <tr>
                    <th colspan="6">
                        Poule {{parseInt(indexPool)+1}}
                    </th>
                </tr>
                <tr>
                    <th>N°</th>
                    <th>Nom</th>
                    <th>J</th>
                    <th>G</th>
                    <th v-if="!tournoiPouleGG">ga</th>
                    <th></th>
                </tr>
                <equipe-item :numero="equipe.numero" :tournoi="tournoi" 
                        :win="equipe.qualifie" 
                        :winScore="equipe.gagnes" 
                        :joues="equipe.joues" 
                        :ga="tournoiPouleGG ? null : equipe.ga" v-for="(equipe) in pool"
                        :rang="tournoiPouleGG ? null : equipe.rang"/> 
               
            </table>
            </div>    
        </div>
        
        <div class="eliminatoires" v-show="tab=='eliminatoire'">
            <div v-for="(partie, indexPartie) in parties" class="eliminatoire" :style="'width: '+widthColumn+'%'">
                    <div class="titlePartie">
                        {{titlePartie(indexPartie, partie, partie.equipes)}}
                    </div>
                    <table v-for="numero in partie.completeJoueurs">
                         <equipe-item :numero="numero" :tournoi="tournoi" :win="true"/> 
                    </table>
                    <div v-for="equipe in partie.equipes"  v-if="partie.type!='ADD' && (partie.justeApsCadrage || partie.type=='CADRAGE')">
                            <table class="equipes2">
                                
                                <equipe-item :numero="equipe.joueurs.J1.numero" :tournoi="tournoi" :win="aGagne(equipe, 'joueurs')"/> 
                                <equipe-item :numero="equipe.contre.J1.numero" :tournoi="tournoi" :win="aGagne(equipe, 'contre')"/> 
                            </table>
                    </div>
                    <div v-for="equipe in partie.equipes" 
                        v-if="!partie.justeApsCadrage && partie.type!='CADRAGE' && partie.type!='ADD'"
                    >
                        <div class="equipes2" :style="'height:'+heightCacul(indexPartie)+'px;'">
                                <table style="height:100%">
                                    
                                     <equipe-item :numero="equipe.joueurs.J1.numero" :tournoi="tournoi" :win="aGagne(equipe, 'joueurs')"/> 
                                      <equipe-item :numero="equipe.contre.J1.numero" :tournoi="tournoi" :win="aGagne(equipe, 'contre')"/> 
                                </table>
                        </div>
                        <div v-if="partie.equipes.length>1" class="accolade2" :style="'height:'+heightCacul(indexPartie)+'px;'">
                            <div class="barre">
                                &nbsp;
                            </div>
                        </div>
                    </div>
                    <div v-for="equipe in partie.equipes" 
                        v-if="partie.type=='ADD'"
                    >
                        <div class="equipes2" :style="'height:'+heightCacul(indexPartie)+'px;'">
                                <table style="height:100%">
                                     <equipe-item :numero="null" :tournoi="tournoi" :win="false"/> 
                                      <equipe-item :numero="null" :tournoi="tournoi" :win="false"/> 
                                </table>
                        </div>
                    </div>
            </div>  
            <div v-if="parties.length==0">
                Non disponible pour le moment, il faut que les phases de poule soient terminées
            </div>
        </div>
    </div>
</div>
</template>
<style scoped>
    table {
        width: 100%;
    }
    .barre {
        height: 100%;
        font-weight: bolder;
        border-top: thin black dashed;
        transform: translateY(50%);
    }
    .accolade2 {
        display: inline-block;
        vertical-align: top;
        margin-top: 5px;
        position: relative;
        width: 5%;
    }
    .titlePartie {
        font-weight: bolder;
        color: black;
    }
    .equipeempty {
        height: 17px;
        
    }
    
    .equipes2 {
        margin-top: 2px;
        border-top: 1px black solid;
        border-bottom: 1px black solid;
        border-right: 1px black solid;
        display: inline-block;
        width: 95%;
    }
    .equipes2 div.subequipes2 {
        vertical-align: bottom;
        border: 1px black red;
    }
    .case {
        display: block;
    }
    .accolade {
        background-image: url("../../assets/accolade.png");
        background-size: cover;
        background-repeat: no-repeat;
        display:inline-block;
        
        vertical-align:top;
       
    }
    .cadrage {
       margin-bottom: 20px;
       border: thin solid black;
    }
    .pools {
        display: inline-block;
        vertical-align: top;
    }
   
    .eliminatoires {
        width: 100%;
        margin-left: 20px;
        vertical-align: top;
        position: relative;
        overflow: auto;
        display: inline-flex;
    }
    .eliminatoire {
       display: inline-block;
       vertical-align: top;
       background-color: white;
       position: relative;
       top: 0px;
      
       padding: 10px;
       text-align: center;
       min-width: 250px;
       
    }
    .pool {
        background-color: silver;
        margin-left: 20px;
        margin-bottom: 20px;
        width: 300px;
        display: inline-block;
        vertical-align: top;
    }
    .gagnant {
        background-color: greenyellow;
    }
    .perdant {
        background-color: rgb(255, 78, 47);
    }
</style>
<script>
import firebase_api from "@/firebase/firebase_api"
import navbarTournoi from "@/views/tournoi/navbar.vue"
import equipeItem from "@/views/tournoi/resultat/equipeItem.vue"
import tournoi_fct from "@/firebase/tournoi"
export default {
    props: ["club","tournoi", "role"],
    components: {
        navbarTournoi,
        equipeItem
    },
    computed: {
        widthColumn: {
            get() {
                var width = 90 / this.parties.length;
                return width;
            }
        },
        tournoiPouleGG: {
            get() {
                var GG = true;
                if (typeof(this.tournoi.options.championnat)!="undefined")
                    if (this.tournoi.options.championnat.type == 'classique')
                        GG = false;
                return GG;
            }
        }
    },
    data() {
        return {
            tab: 'eliminatoire',
            height: 50,
            top: 5,
            resultatPouleDefinif: false,
            modalCloturer: false,
            pools:[],
            poolsResultats:[],
            parties: [],      
            
            accolades: [
                {
                    prems: '10px',
                    after: '0px',
                    height: '50px',
                    width: '20px'
                },
                {
                    prems: '10px',
                    after: '0px',
                    height: '120px',
                    width: '40px'
                },
                {
                    prems: '50px',
                    after: '0px',
                    height: '200px',
                    width: '40px'
                },
                {
                    prems: '100px',
                    after: '87.5px',
                    height: '370px',
                    width: '40px'
                },
                 {
                    prems: '220px',
                    after: '180px',
                    height: '700px',
                    width: '40px'
                }

            ]      
        }
    },
    methods: {
        coeff(indexPartie) {
            // il faut qu'on regarde par rapport au cadrage
            var indexCadrage = null;
            this.parties.forEach((partie, indexPartie)=> {
                if (partie.type=='CADRAGE')
                    indexCadrage = indexPartie;
            })
            if (indexPartie > indexCadrage) {
                var indexCalc = indexPartie - indexCadrage;
                if (indexCalc == 1) {
                    return indexCalc;
                }
                else {
                    indexCalc = indexCalc - 1;
                    return Math.pow(2, indexCalc);
                }
            }
            else if (indexPartie == 0)
                return 1;
            else 
                {
                    var indexCalc = indexPartie;
                    indexCalc = indexCalc - 1;
                    return Math.pow(2, indexCalc);
                }
        },
        heightCacul(indexPartie) {
            var height = this.height;
            //height = height * this.coeff(indexPartie);
           
            var nbPartie = indexPartie;
        
            
            for (var i=0;i<indexPartie;i++)
                height += height  +10;
         
            return height;
        },
        sZoom() {
            document.body.style.zoom = "50%";
        },
         cloturer() {
             this.tournoi.state = "FINISH";
            tournoi_fct.object.set(this.club, this.tournoi, ()=>{
                this.modalCloturer = false;
            })
        },
       titlePartie(index, partie, equipes) {
                var index = index + 1;
            

                if (partie.type=="TOUR1")
                    return "TOUR 1"
                if (partie.type=="TOUR2")
                    return "TOUR 2"
                if (partie.type=="BARRAGE")
                    return "BARRAGE"
                if (partie.type=="CADRAGE")
                    return "CADRAGE"
                if (partie.type=="ELIMINATOIRE" || partie.type=='ADD') {
                    var nbEquipes = 0;
                    /*
                    equipes.forEach(equipe=>{
                        if (equipe.contre.J1!=null)
                            nbEquipes = nbEquipes + 2;
                        else
                            nbEquipes ++;
                    })*/
                    nbEquipes = equipes.length*2;
                    if (nbEquipes == 2)
                        return "FINALE";
                    else if (nbEquipes == 4)
                        return "DEMI FINALE"
                    else if (nbEquipes == 8)
                        return "QUART de FINALE"
                    else if (nbEquipes == 16)
                        return "8ème de FINALE"
                    else if (nbEquipes == 32)
                        return "16ème de FINALE"
                    else    
                        return "ELIMINATOIRE"
                } 
        },
        
        aGagne(equipe,vs) {
            var vsvs = vs == 'joueurs' ? 'contre' : 'joueurs';
            if (equipe.contre.J1.numero==null)
                return null;
            else if (equipe.score['joueurs']==null || equipe.score['contre']==null)
                return null;
            else if (equipe.score[vs]>equipe.score[vsvs])
                return true;
            else
                return false;
        },
        posAccolade (indexEquipe, indexElimininatoire) {
            var styleCssPadding = "";
            var styleCssHeight = "";
            var height = this.accolades[indexElimininatoire].height;
            var prems = this.accolades[indexElimininatoire].prems;
            var width = this.accolades[indexElimininatoire].width;
            var after = this.accolades[indexElimininatoire].after;
            styleCssPadding = 'margin-top:'+prems;
            styleCssHeight = 'background-size: '+width+' '+' '+ height +';height:'+height+';width:'+width;
            return styleCssPadding + ";" + styleCssHeight;
        },
        
    },
    async mounted() {



        var indexPartieEliminatoire = 0;
        var cadrage = false;
        var indexElimininatoire = 0;
        var parties = await firebase_api.api.getDb().collection("club").doc(this.club.id)
            .collection("tournois").doc(this.tournoi.id).collection("parties").get();
        this.poolsResultats = [];
    
        for (var indexPool in this.tournoi.pools) {
            var pool = this.tournoi.pools[indexPool];
            this.poolsResultats[indexPool] = {};
            pool.forEach(equipe=>{
                var json = {
                    numero: equipe,
                    joues: 0,
                    gagnes: 0,
                    ga: 0,
                    qualifie: null,
                    rang : null
                } 
                this.poolsResultats[indexPool][equipe] = json;    
            })
        }
        
        if (!this.tournoiPouleGG)
            if (typeof(this.tournoi.options.resultatPoule)!="undefined")
                this.resultatPouleDefinif = true;
        for (var indexPartie in parties.docs) {
            
            var partieData = parties.docs[indexPartie].data();
            if (indexPartie<3) {
                var equipes = await parties.docs[indexPartie].ref.collection("equipes").get();
                 equipes.docs.forEach((equipeDoc, indexEquipe) => {
                     var equipeData = equipeDoc.data();
                     if (equipeData.score.joueurs!=null) {
                         var joueurJ1 = equipeData.joueurs.J1 != null ? equipeData.joueurs.J1.numero : null;
                         var contreJ1 = equipeData.contre.J1 != null ? equipeData.contre.J1.numero : null;
                         var scoreJoueurJ1 = equipeData.score.joueurs - equipeData.score.contre;
                         var scoreContreJ1 = equipeData.score.contre - equipeData.score.joueurs;
                         var findPool = this.poolsResultats[equipeData.pool];
                         if (joueurJ1!=null) {
                            var findEquipeJ1 = findPool[joueurJ1];
                            findEquipeJ1.joues++;
                            if (scoreJoueurJ1>0)
                                findEquipeJ1.gagnes++;
                            findEquipeJ1.ga+=scoreJoueurJ1;
                            if (this.resultatPouleDefinif && !this.tournoiPouleGG) {
                                if (typeof(this.tournoi.options.resultatPoule[equipeData.pool])!="undefined") {
                                    var findEquipeResultat = this.tournoi.options.resultatPoule[equipeData.pool][joueurJ1];
                                    if (typeof(findEquipeResultat)!="undefined")
                                        findEquipeJ1.qualifie = findEquipeResultat.qualifie;
                                }
                            }
                         }
                          
                         if (contreJ1!=null) {
                            var findEquipeJ1 = findPool[contreJ1];
                            findEquipeJ1.joues++;
                            if (scoreContreJ1>0)
                                findEquipeJ1.gagnes++;
                            findEquipeJ1.ga+=scoreContreJ1;
                            if (this.resultatPouleDefinif && !this.tournoiPouleGG) {
                                if (typeof(this.tournoi.options.resultatPoule[equipeData.pool])!="undefined") {
                                    var findEquipeResultat = this.tournoi.options.resultatPoule[equipeData.pool][contreJ1]
                                    if (typeof(findEquipeResultat)!="undefined")
                                        findEquipeJ1.qualifie = findEquipeResultat.qualifie;
                                }
                            }
                         }
                        
                     }
                     
                     if (indexEquipe == equipes.docs.length-1 && indexPartie==2) {
                        // Set qualifie pour le tournoi classique
                        if (this.resultatPouleDefinif && !this.tournoiPouleGG) {
                           
                            var resultat = [];
                            this.poolsResultats.forEach((pool, indexPool)=>{
                                resultat[indexPool]=[];
                                for (var itemPool in pool)
                                    resultat[indexPool].push(pool[itemPool]);
                            })
                         
                            this.poolsResultats.forEach((pool, indexPool)=>{
                                var resultatPool = resultat[indexPool];
                                resultatPool.sort((e1,e2)=>{
                                   return e2.gagnes - e1.gagnes || e2.ga - e1.ga;
                                })  
                                for (var itemPool in pool) {
                                    var index = resultat[indexPool].findIndex(elt=>elt.numero === pool[itemPool].numero);
                                    pool[itemPool].rang = index+1;
                                }
                            })
                        }
                        // Set qualifie pour le tournoi en mode GG
                        if (partieData.type=="BARRAGE" && this.tournoiPouleGG) {
                             this.poolsResultats.forEach((pool, indexPool)=>{
                                
                                partieData.pools[indexPool].gagnants.forEach(numero=>{
                                    pool[numero].qualifie = true;
                                })
                                 partieData.pools[indexPool].perdants.forEach(numero=>{
                                    if (typeof(pool[numero])!="undefined")
                                        pool[numero].qualifie = false;
                                })
                            })
                        }
                    }
                 })
                }
            if (partieData.type=="BARRAGE") {
                this.pools = partieData.pools;
                
                this.resultatPouleDefinif = true;
            }
            else  if (partieData.type=="CADRAGE" || partieData.type=="ELIMINATOIRE") {
                var equipes = await parties.docs[indexPartie].ref.collection("equipes").get();
                partieData.justeAvvCadrage = cadrage;
                partieData.justeApsCadrage = false;
                partieData.indexElimininatoire = indexElimininatoire;
                partieData.equipes = [];
                equipes.docs.forEach(equipeDoc => {
                  
                    partieData.equipes.push(equipeDoc.data())
                });
                if (partieData.type=="CADRAGE") {
                    cadrage = true;
                    indexElimininatoire=-1;
                    if (typeof(this.parties[this.parties.length-1])!="undefined")
                        this.parties[this.parties.length-1].justeApsCadrage = true;
                }
                else 
                    cadrage = false;
                this.parties.push(partieData);
                
                
                
                
                indexElimininatoire++;

            }
        }
        this.tab = this.parties.length == 0 ? 'poules' : 'eliminatoire'
        if ((this.tournoi.cadrage || !this.tournoiPouleGG) && this.parties.length>0) {
            var displaySimulateParties = false;
            if (this.parties[this.parties.length-1].type!='CADRAGE' || !this.tournoiPouleGG) {
                displaySimulateParties = true;
            }
            if (displaySimulateParties) {
               var nbEquipeADD=0;
                if (this.parties.length==0) {
                    nbEquipeADD = this.poolsResultats.length;
                }
                else {
                     nbEquipeADD = this.parties[this.parties.length-1].equipes.length;
                }
                
                var tantQue = true;
                while (tantQue) {
                    nbEquipeADD = nbEquipeADD/2;
                    if (nbEquipeADD>=1) {
                        var partie = {
                            type: "ADD",
                            equipes: []
                        }
                       
                        for (var i=0;i<nbEquipeADD;i++)
                            partie.equipes.push("?");
                        this.parties.push(partie);
                    }
                    else
                        tantQue = false;
                }
            }
        }
        
    }
}
</script>